import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icons/challenges/student/empty-state.svg",
  alt: "empty state",
  class: "empty-state"
}, null, -1)
const _hoisted_3 = { class: "p-text-center p-mt-3 p2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    bgDark: "",
    border: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, _toDisplayString($props.text), 1)
      ])
    ]),
    _: 1
  }))
}